import { render, staticRenderFns } from "./PaktaIntegritasGEMS.vue?vue&type=template&id=26356232&"
import script from "./PaktaIntegritasGEMS.vue?vue&type=script&lang=js&"
export * from "./PaktaIntegritasGEMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports